import { render } from "./View02.vue?vue&type=template&id=c45e1288&scoped=true"
import script from "./View02.vue?vue&type=script&lang=js"
export * from "./View02.vue?vue&type=script&lang=js"

import "./View02.vue?vue&type=style&index=0&id=c45e1288&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45e1288"]])

export default __exports__